import { ComponentChild } from 'preact'
import { PureComponent } from 'preact-compat'

import { ContentType } from '@insided/shared/utils/contentType'
import { Author, IdeaStatus, Topic } from '../interfaces'
import AssignModerator from './AssignModerator'
import ChangeIdeationStatus from './ChangeIdeationStatus'
import MergeIdea from './MergeIdea'
import ChangePublicLabel from './ChangePublicLabel'
import MoreOptions from './MoreOptions'
import { backToOverviewLink } from './utils'
import { ConfigContext } from '../utils'

/* eslint-disable import/no-internal-modules */
import { User } from '@insided/deprecated-preact-components/user-selector/User'
import { ParentCategory } from '@insided/deprecated-preact-components/category-selector/CategorySelector'
import Header from '@insided/deprecated-control/header'
import Button from '@insided/control/uikit/Button'

interface TopicHeaderProps {
  topic: Topic
  contentType: ContentType
  ideationStatus: IdeaStatus | null
  ideationStatuses: IdeaStatus[]
  onShowAlert: (type: 'success' | 'error', message?: string) => void
  onIdeationStatusChanged: (ideationStatus: IdeaStatus) => void
  getReplies: () => void
  assignedModerator?: User
  onModeratorAssigned: (moderator?: User) => void
  selectedPublicLabel: string | null
  onPublicLabelInput: (publicLabel: string) => void
  onPublicLabelChanged: (publicLabel: string) => void
  trashed: boolean
  spam: boolean
  handleToggleSpamModal: () => void
  onTrash: (trashed: boolean) => void
  publicLabelText: string
  phrases?: {
    [key: string]: string
  }
  categories: ParentCategory[]
  setMessage: (message?: ComponentChild) => void
  hasPinnedReply: boolean
  onChangeAuthor: (author: Author) => void
}

class TopicHeader extends PureComponent<TopicHeaderProps> {
  headerActions () {
    const { topic, contentType, ideationStatus, ideationStatuses, onIdeationStatusChanged, onShowAlert, getReplies, assignedModerator, onModeratorAssigned, selectedPublicLabel, onPublicLabelChanged, onPublicLabelInput, trashed, spam, handleToggleSpamModal, onTrash, publicLabelText, phrases, categories, setMessage, hasPinnedReply, onChangeAuthor } = this.props

    return (
      <ConfigContext.Consumer>
        {({ contentTypeConfig }) => {
          return (
            <div className='header-actions-wrapper'>
              {contentTypeConfig.versionHistory &&
                <Button
                  title='Version History'
                  onClick={() => { window.location.assign(`/article/${topic.id}/versions`) }}
                  data-qa='version-history'
                />}
              {contentTypeConfig.ideaStatus &&
                <ChangeIdeationStatus
                  topicId={topic.id}
                  contentType={contentType}
                  ideationStatus={ideationStatus as IdeaStatus}
                  ideationStatuses={ideationStatuses}
                  onIdeationStatusChanged={onIdeationStatusChanged}
                  onShowAlert={onShowAlert}
                  getReplies={getReplies}
                />}
              {contentTypeConfig.ideaStatus &&
                <MergeIdea
                  contentType={contentType}
                  fromIdea={topic}
                  ideaStatus={ideationStatus as IdeaStatus}
                  ideaStatuses={ideationStatuses}
                  onShowAlert={onShowAlert}
                />}
              {contentTypeConfig.assignModerator &&
                <AssignModerator
                  topicId={topic.id}
                  contentType={contentType}
                  assignedModerator={assignedModerator}
                  onModeratorAssigned={onModeratorAssigned}
                  onShowAlert={onShowAlert}
                />}
              {contentTypeConfig.publicLabel &&
                <ChangePublicLabel
                  contentType={contentType}
                  topicId={topic.id}
                  selectedPublicLabel={selectedPublicLabel}
                  onShowAlert={onShowAlert}
                  onPublicLabelChanged={onPublicLabelChanged}
                  onPublicLabelInput={onPublicLabelInput}
                  publicLabelText={publicLabelText}
                  phrases={phrases}
                />}
              <MoreOptions
                topicId={topic.id}
                publicId={Number(topic.publicId)}
                contentType={contentType}
                trashed={trashed}
                spam={spam}
                handleToggleSpamModal={handleToggleSpamModal}
                onTrash={onTrash}
                onShowAlert={onShowAlert}
                categories={categories}
                setMessage={setMessage}
                hasPinnedReply={hasPinnedReply}
                onChangeAuthor={onChangeAuthor}
              />
            </div>
          )
        }}
      </ConfigContext.Consumer>
    )
  }

  render () {
    const { contentType } = this.props
    return (
      <Header
        title='Moderate Topic'
        disableSaveButton
        disableCancelButton
        hasBreadcrumb
        breadcrumbLink={backToOverviewLink[contentType]?.link}
        breadcrumbText={backToOverviewLink[contentType]?.name}
        customButtons={[this.headerActions()]}
      />
    )
  }
}

export default TopicHeader
